export default "__VITE_ASSET__Cl8YVQ4k__"